import dat from "three/examples/js/libs/dat.gui.min.js";

// Auswahlmöglichkeiten Intensity
let hemiLuminousIrradiances = {
    "0.0001 lx (Moonless Night)": 0.0001,
    "0.002 lx (Night Airglow)": 0.002,
    "0.005 lx": 0.005,
    "0.01 lx": 0.01,
    "0.05 lx": 0.05,
    "0.1 lx": 0.1,
    "0.2 lx": 0.2,
    "0.3 lx": 0.3,
    "0.5 lx (Full Moon)": 0.5,
    "1 lx (Normal)": 1,
    "3.4 lx (City Twilight)": 3.4,
    "10 lx (Dark Room)": 10,
    "30 lx (Shady Room)": 30,
    "50 lx (Living Room)": 50,
    "100 lx (Very Overcast)": 100,
    "350 lx (Office Room)": 350,
    "400 lx (Sunrise/Sunset)": 400,
    "1000 lx (Overcast)": 1000,
    "18000 lx (Daylight)": 18000,
    "50000 lx (Direct Sun)": 50000
};

// Auswahlmöglichkeiten Power
let bulbLuminousPowers = {
    "110000 lm (1000W)": 110000,
    "3500 lm (300W)": 3500,
    "1700 lm (100W)": 1700,
    "800 lm (60W)": 800,
    "400 lm (40W)": 400,
    "180 lm (25W)": 180,
    "100 lm": 100,
    "50 lm": 50,
    "20 lm (4W)": 20,
    "17 lm": 17,
    "15 lm": 15,
    "12 lm": 12,
    "10 lm": 10,
    "7 lm": 7,
    "5 lm": 5,
    "3 lm": 3,
    "Off": 0
};

const lightParams = {
    color: undefined,
    intensity: undefined,
    positionX: undefined,
    positionY: undefined,
    positionZ: undefined,
    castShadow: undefined,
};

// Parameter der jeweiligen Lichter, können ergänzt werden, wenn das Licht die jeweilige Property
// besitzt
const lightInfos = [
    {
        name: "AmbientLight",
        typ: THREE.AmbientLight,
        params: Object.assign({}, lightParams, {}),
        helper: (light) => {
            const h = new THREE.Group();
            h.update = ()=>{};
            return h;
        },
    },
    {
        name: "DirectionalLight",
        typ: THREE.DirectionalLight,
        params: Object.assign({}, lightParams, {
            targetX: undefined,
            targetY: undefined,
            targetZ: undefined
        }),
        helper: (light) => new THREE.DirectionalLightHelper(light)
    },
    {
        name: "HemisphereLight",
        typ: THREE.HemisphereLight,
        params: {
            color: undefined,
            groundColor: undefined,
            intensity: undefined,
            positionX: undefined,
            positionY: undefined,
            positionZ: undefined,
            castShadow: undefined
        },
        helper: (light) => new THREE.HemisphereLightHelper(light),
    },
    {
        name: "PointLight",
        typ: THREE.PointLight,
        params: Object.assign({}, lightParams, {
            distance: undefined,
            decay: undefined,
            power: undefined
        }),
        helper: (light) => new THREE.PointLightHelper(light),
    },
    {
        name: "RectAreaLight",
        typ: THREE.RectAreaLight,
        params: Object.assign({}, lightParams, {
            width: undefined,
            height: undefined,
        }),
        helper: (light) => new THREE.RectAreaLightHelper(light),
    },
    {
        name: "SpotLight",
        typ: THREE.SpotLight,
        params: Object.assign({}, lightParams, {
            distance: undefined,
            decay: undefined,
            power: undefined
        }),
        helper: (light) => new THREE.SpotLightHelper(light),
    }
];


class datLight extends HTMLElement {

    helper = [];

    constructor() {
        super();
        this.gui = new dat.GUI({ autoPlace: false });
        this.gui.domElement.id = 'datgui';
        this.gui.domElement.classList.add("datgui");
        this.gui.close();
    }

    connectedCallback() {
        this.createLightGui();
        this.render();
    }

    setGuiDirty() {
        this.gui.destroy();
        this.removeChild(this.gui.domElement);
        this.gui = undefined;
        this.gui = new dat.GUI({ autoPlace: false });
        this.gui.domElement.id = 'datgui';
        this.gui.domElement.classList.add("datgui");
        this.createLightGui();
        this.render();
    }

    updateRenderSettings() {
        Textures.getMaterials().forEach(m => m.needsUpdate = true);
        STAGE.dirty();
    }

    // Erstellt Light Dat GUI aufgrund von allen Lichtern in der Szene
    createLightGui() {
        this.gui.add({ Helper: false }, "Helper").onChange(e => {
            this.setLightHelpers(e);
        })
        if (STAGE) {
            let dats = [];
            this.getLightsWithInfo().forEach(({light,info},index)=>{
                const params = info.params;
                let folder = this.gui.addFolder(index + ". " + info.name);
                for (let prop in params) {
                    if (prop === "positionX") params[prop] = light["position"]["x"];
                    else if (prop === "positionY") params[prop] = light["position"]["y"];
                    else if (prop === "positionZ") params[prop] = light["position"]["z"];
                    else if (prop === "targetX") params[prop] = light["target"]["position"]["x"];
                    else if (prop === "targetY") params[prop] = light["target"]["position"]["y"];
                    else if (prop === "targetZ") params[prop] = light["target"]["position"]["z"];
                    else params[prop] = light[prop];

                    // if (prop === "intensity") {
                    //     hemiLuminousIrradiances[version + ". " + l.Typ + " " + Math.round(light[prop] * 100) / 100 + " lx"] = light[prop];
                    // }

                    if (prop === "power") {
                        bulbLuminousPowers[index + ". " + light.Typ + " " + Math.round(light[prop]) + "W"] = light[prop];
                    }

                    let dat;
                    const optionalParameters = this.getPropValues(prop);
                    if (prop === "color" || prop === "groundColor") {
                        params[prop] = "#" + params[prop].getHexString();
                        dat = folder.addColor(params, prop);
                    } else if(prop === "intensity") {
                        dat = folder.add(params, prop, 0, 20000, 0.1);
                    } else {
                        dat = folder.add(params, prop, ...optionalParameters);
                    }
                    dats.push(dat);
                }
                folder.close();
                dats.forEach(dat => {
                    dat.onChange((e) => this.handleChange(e, light, dat.property));
                });
                dats = [];
            });
        }
    }

    // Evtl zusätzliche Parameter für DAT Gui
    getPropValues(prop) {
        if (prop === "power") {
            return [Object.keys(bulbLuminousPowers)];
        } else if (prop === "intensity") {
            return [Object.keys(hemiLuminousIrradiances)];
        }
        return [];
    }

    // Änderung in der Dat
    handleChange(value, light, property) {
        if (property === "color" || property === "groundColor") value = new THREE.Color("rgb(" + this.hexToRgb(value).r + "," + this.hexToRgb(value).g + "," + this.hexToRgb(value).b + ")");
        if (property === "positionX") light["position"]["x"] = value;
        else if (property === "positionY") light["position"]["y"] = value;
        else if (property === "positionZ") light["position"]["z"] = value;
        else if (property === "targetX") light["target"]["position"]["x"] = value;
        else if (property === "targetY") light["target"]["position"]["y"] = value;
        else if (property === "targetZ") light["target"]["position"]["z"] = value;
        else if (property === "power") light[property] = bulbLuminousPowers[value];
        else if (property === "intensity") light[property] = value;//hemiLuminousIrradiances[value];
        else light[property] = value;
        this.update(light);
    }

    update(light) {
        if (light && light.target) light.target.updateMatrixWorld();
        STAGE.renderSceneOnce();
    }

    setLightHelpers(bool) {
        if (bool) {
            this.getLightsWithInfo().forEach(({light,info}) => {
                const helper = info.helper(light);
                STAGE.scene.add(helper);
                this.helper.push(helper);
                helper.update();
            })
            const materialHelper = Debugs.addMaterialHelper();

            materialHelper.position.x += parseFloat(this.getAttribute('mh-x-offset')) || 0;
            materialHelper.position.y += parseFloat(this.getAttribute('mh-y-offset')) || 0;
            materialHelper.position.z += parseFloat(this.getAttribute('mh-z-offset')) || 0;

            this.helper.push(materialHelper);
        } else {
            this.helper.forEach(h => STAGE.scene.remove(h));
        }
        this.update();
    }

    getLightsWithInfo() {
        const entries = [];
        STAGE.scene.traverse(o=>{
            const info = lightInfos.find(info=>o instanceof info.typ);
            if (info) {
                entries.push({light:o,info});
            }
        });
        return entries;
    }

    // Für Farben
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    // Styling versucht externes Styling zu verhindern und eigenes fest zu nageln, hier können "Erweiterungen" nötig sein. Allerdings nichts entfernen, damit alle Projekte lauffähig bleiben
    render() {
        this.innerHTML = `
        <style>
        ocdat-light {
            position: relative;
        }
        ocdat-light .datgui {
            background-color: black;
        }
        ocdat-light select {
            /*line-height: 15px;*/
            /*height: 15px;*/
            /*min-height: 15px;*/
            padding: 0px 0px;
            /*border-radius: 0px !important;*/
            -webkit-appearance: searchfield !important;
            margin-top: 0px !important;
            width: 100%;
            color: #000000;
        }
        ocdat-light input {
            line-height: initial !important;
            min-height: 20px !important;
            font-size: inherit !important;
        }
        ocdat-light input[type="checkbox"] {
            margin-top: 4px !important;
            -webkit-appearance: checkbox;
            display: block;
        }
        ocdat-light li {
            margin-bottom: 0 !important;
        }
        </style>
        `
        this.appendChild(this.gui.domElement);
    }
}
customElements.define('ocdat-light', datLight);
